export const roundAverageProductRating = (averageProductRating: number | null | undefined) => {
  return averageProductRating ? Number(averageProductRating.toFixed(1)) : 0;
};
